module.exports = __webpack_public_path__ + "img/feature-details.75d713c.png";